import getConfig from 'next/config';
import {
  WEB_SCHEMA,
  WEBPAGE_SCHEMA_TYPE,
} from '../../../constants/stocks/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { b2cData } from '../../cms/layout/components/header';
import { ClearInNavbar } from '../../Navbar/ClearNavbar';
import { GoldSilverLayoutProps, METALS, SILVER_CITY } from '../common/types';
import { replaceCMSDate } from '../common/utils';
import { SilverCityHomepage } from '../silver-city-page';
import { StocksLayout } from './stocks-layout';
import { getFullDateWithOrdinals } from '../../Utils/UtilFunctions';

const { publicRuntimeConfig } = getConfig();

const SilverPageLayout = ({
  city,
  data,
  cities,
  graphData,
  top_cta,
  cmsContent,
  cmsFaq,
  cmsMeta,
}: GoldSilverLayoutProps): JSX.Element => {
  const todayDate = getFullDateWithOrdinals(new Date().toDateString());
  const seoDetails: WEBPAGE_SCHEMA_TYPE = {
    title: replaceCMSDate(cmsMeta?.meta_title ?? '', todayDate),
    metaDesc: replaceCMSDate(cmsMeta?.description ?? '', todayDate),
    url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/${METALS.SILVER}-rate-${city}`,
  };

  return (
    <StocksLayout
      slider={false}
      meta={
        <Meta
          title={seoDetails.title}
          description={seoDetails.metaDesc}
          canonical={seoDetails.url}
          keywords={cmsMeta?.keywords ?? ''}
        />
      }
    >
      <ClearInNavbar data={b2cData} />

      <SilverCityHomepage
        goldData={data as SILVER_CITY}
        cityData={cities}
        city={{ type: 'major', name: city }}
        graphData={graphData}
        metal={METALS.SILVER}
        top_cta={top_cta}
        cmsContent={cmsContent}
        cmsFaq={cmsFaq}
        cmsTitle={cmsMeta?.title}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(WEB_SCHEMA(seoDetails)),
        }}
      ></script>
    </StocksLayout>
  );
};

export default SilverPageLayout;
